
Checkout.Shipping = function(checkout) {
	var shipping = this;

	this.saved = true;

	this.$wrap = $('#shipinfowrapper');
	this.$anchor = $('a[name=shipping]');
	this.$loadingOverlay = $('#shipping-loading-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
	this.$proceed = $('#shipping-proceed');

	this.$cShopping = this.$wrap.find('.cshopping');
	this.$showEmailCart = this.$wrap.find('#showEmailCart');
	this.$serviceGroupsWrap = $('.shipping-service-groups-wrap');
	this.$servicesContent = $('#shipping-services-content-main');
	this.$servicesContentAlt = $('#shipping-services-content-alt');
	this.$servicesContentAltWrap = $('.pickcarrierAlt');
	this.$servicesContentAll = $('.shipping-services-content');
	this.$serviceServicesWrap = $('.shipping-service-couriers-wrap');
	this.$couriers = $('#shipping-couriers');
	this.$couriersContent = $('#shipping-couriers-content');
	this.$serviceTpl = $('#shipping-service-tpl');
	this.$courierServicesTpl = $('#shipping-courier-services-tpl');
	this.$serviceDesc = $('#shipping-service-desc');
	this.$disclaimers = $('#shipping-map');

	this.$overrideWrap = $('#shipping-override-wrap');
	this.$override = $('#shipping-override');
	this.$overrideAmt = $('#shipping-override-amt');
	this.$displayTypeSelect = $('#shipping-switch-displaytype-select');

	this.$groupDetailsContainer = $('#shipping-group-details-container');

	this.init = function() {
		shipping.listen();
	};

	this.listen = function() {

		shipping.$proceed.click(shipping.proceed);

		shipping.$displayTypeSelect.change(shipping.changeDisplayType);

		shipping.$override.change(shipping.changeOverride);

		shipping.$overrideAmt.bind('input propertychange', shipping.changeOverride);

		// listen for cart content changes

		checkout.cart.$wrap.on('loading', function(e, loadingMsg) {
			shipping.loading(loadingMsg);
		});

		checkout.cart.$wrap.on('loadDone', function(e, stepChanged) {

			shipping.loading(false);

			if (
				checkout.session.get('step') != 'cart'
				&& stepChanged == 'cart'
			)
				shipping.buildContent();

		});

		checkout.cart.$wrap.on('loadFail', function(e) {
			shipping.loading(false);
			shipping.$wrap.hide();
		});
	};

	this.buildContent = function() {
		shipping.$serviceGroupsWrap.hide();
		shipping.$servicesContentAltWrap.hide();
		shipping.$groupDetailsContainer.hide();
		shipping.$serviceServicesWrap.hide();
		if (Object.keys(checkout.shippingRates).length > 0) {
			shipping.buildServiceOptions();
		} else {
			shipping.buildServiceGroupOptions();
		}
		shipping.showDisclaimers();
		shipping.buildOverride();
		shipping.$cShopping.show();
		shipping.$wrap.show();
	};

	this.stepTo = function() {

		if (checkout.session.get('step') == 'cart')
			checkout.session.set({
				'step': 'shipping'
			});

		if (
			(
				checkout.session.get('step') != 'shipping'
				&& checkout.session.isLoggedIn()
			)
			|| checkout.session.get('PayPalConfirmed')
		)
			shipping.proceed();
		else {

			checkout.session.set({
				'step': 'shipping'
			});

			shipping.$proceed.show();


			$('html,body').animate(
				{ 'scrollTop': shipping.$anchor.offset().top },
				500
			);

		}
	};

	this.proceed = function() {
		shipping.$proceed.hide();
		shipping.$cShopping.hide();
		checkout.login = new Checkout.Login(checkout);
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			shipping.$loadingMsg.html(loadingMsg);
			shipping.$loadingOverlay.show();
			checkout.alignMiddle(shipping.$loadingOverlay.find('.msg'), shipping.$loadingOverlay);
		} else
			shipping.$loadingOverlay.hide();
	};

	this.buildServiceGroupOptions = function() {
		var selectedServiceGroup = checkout.shippingServiceGroupRates[checkout.shippingServiceGroupID]
            , groupRatesSorted = []
            , groupRatesElements = []
            , groupRatesElementsAlt = []

		for (var shippingServiceGroupID in checkout.shippingServiceGroupRates) {
            groupRatesSorted.push(checkout.shippingServiceGroupRates[shippingServiceGroupID]);
        }

        groupRatesSorted.sort(function(a, b) {
            if (!(a.inStorePickup||0) && (b.inStorePickup||0))
                return -1;
            return (a.price - b.price);
        });

        $.each(groupRatesSorted, function(i, groupRate) {
            var $service =
                shipping.$serviceTpl
                    .clone(true)
                    .attr('id', 'shipping-service-group-'+groupRate.shippingServiceGroupID);

            $service.find('.shipping-service-name').html(groupRate.cartName);
			if (checkout.cart.showShipOptionsETA && Object.keys(groupRate.deliveryETA).length) {
				var deliveryETA = isoDateFormatter(groupRate.deliveryETA["1"],true);
				if (groupRate.deliveryETA["2"]) {
					deliveryETA += " - " + isoDateFormatter(groupRate.deliveryETA["2"],true);
				}
            	$service.find('.shipping-service-daysTransit').html(deliveryETA);
				$('.shipping-daysTransit-header').html("ESTIMATED DELIVERY DATE");
			} else {
				$service.find('.shipping-service-daysTransit').html(groupRate.daysInTransit);
			}

            var rawCostHTML = '';
            if ('rawCost' in groupRate) {

                var colorAlert = '';
                if (parseFloat(groupRate.rawCost) > parseFloat(groupRate.price)) {
                    colorAlert = 'style="color:red"';
                }

                rawCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert + '>($' + commaSeparate(groupRate.rawCost) + ')</em> ';

            }

            var shipServicePriceHTML = rawCostHTML;
			if (groupRate.originalShippingRetail > 0 && parseFloat(groupRate.originalShippingRetail) > parseFloat(groupRate.price)) {
				$service.find('label.radio').addClass('special-offer');
				shipServicePriceHTML += '<span class="saleTxt">'+groupRate.costMessage+'</span>';
				shipServicePriceHTML += '<span class="pricecut">$'+commaSeparate(groupRate.originalShippingRetail)+'</span>';
				shipServicePriceHTML += '<span class="discountedCost">$'+commaSeparate(groupRate.price)+'</span>';
			} else if (groupRate.price > 0) {
                shipServicePriceHTML += '$'+ commaSeparate(groupRate.price);
            } else {
                shipServicePriceHTML += '<div style="color:#1faf52;display:inline-block">FREE</div>';
            }

            $service.find('.shipping-service-price').html(shipServicePriceHTML);

            if (selectedServiceGroup.shippingServiceGroupID == groupRate.shippingServiceGroupID)
                $service.find('input[type=radio]').prop('checked', true);

            if (groupRate.internalOnly) {
                groupRatesElementsAlt.push($service)
            } else {
                groupRatesElements.push($service);
            }

		});

		shipping.$servicesContent.html(groupRatesElements);
		shipping.$servicesContentAlt.html(groupRatesElementsAlt);

        if (groupRatesElementsAlt.length) {
            shipping.$servicesContentAltWrap.show();
        } else {
            shipping.$servicesContentAltWrap.hide();
        }

        shipping.showRatesDetails( selectedServiceGroup );

		// listen for explicit service change
		shipping.$servicesContentAll
			.find('input[type=radio]')
			.change(function() {
				var shippingServiceGroupID =
					$(this)
						.parents('.shipping-service')
						.first()
						.attr('id')
						.replace('shipping-service-group-', '');

				checkout.session.set({
					'shippingServiceGroupSet': 1
				});

				shipping.changeServiceGroup(shippingServiceGroupID);
			});

		shipping.$serviceGroupsWrap.show();
	};

	this.changeServiceGroup = function(shippingServiceGroupID) {
		var groupRate = checkout.shippingServiceGroupRates[shippingServiceGroupID];

		checkout.session.set({
			'shippingServiceGroupID': shippingServiceGroupID,
		});

		if (
			checkout.user
			&& !checkout.session.get('shippingOverride')
		) {
			shipping.$overrideAmt.val((parseFloat(groupRate.price) || 0).toMoney());
        }

		checkout.shippingServiceGroupID = shippingServiceGroupID;

		checkout.cart.shipping.total = (parseFloat(groupRate.price) || 0);
		checkout.cart.shipping.originalShippingRetail = (parseFloat(groupRate.originalShippingRetail) || 0);

		checkout.cart.totals.update('shipping');
        
        shipping.showRatesDetails( groupRate );
	};
	
	this.buildServiceOptions = function() {
		var selectedService = checkout.shippingServices[checkout.shippingServiceCode],
			courierRates = {},
			couriersHideOthersWhenAvail = {},
			courierTabs = [],
			couriersContent = [],
			invalidCourierRates = {};

		for (var shippingServiceCode in checkout.shippingRates) {
			var rate = checkout.shippingRates[shippingServiceCode];

			if (!courierRates[rate.shippingCourierCode]) {
				courierRates[rate.shippingCourierCode] = {};
			}

			courierRates[rate.shippingCourierCode][shippingServiceCode] = rate;
		}

		// build the data structure for invalid shipping Rates 
		if (checkout.invalidShippingRates) { 
			for (var shippingServiceCode in checkout.invalidShippingRates) { 
				var invalidRate = checkout.invalidShippingRates[shippingServiceCode]; 

				if (!invalidCourierRates[invalidRate.shippingCourierCode]) {
					invalidCourierRates[invalidRate.shippingCourierCode] = {}; 
				}

				invalidCourierRates[invalidRate.shippingCourierCode][shippingServiceCode] = invalidRate; 
			} 
		}
		
		$.each(checkout.shippingCouriers, function(i, courier) {
			if (
				courier.hideOthersWhenAvailable
				&& (courier.shippingCourierCode in courierRates)
			) {
				couriersHideOthersWhenAvail[courier.shippingCourierCode] = 1;
			}
		});

		shipping.couriers = {};

		$.each(checkout.shippingCouriers, function(i, courier) {
			var hasRates = (courier.shippingCourierCode in courierRates);

			if (!hasRates) {
				if (courier.hideWhenUnavailable) {
					return;
				} else if (
					Object.keys(couriersHideOthersWhenAvail).length
					&& !couriersHideOthersWhenAvail[courier.shippingCourierCode]
				) {
					return;
				}
			}

			var anchor = '<a data-toggle="tab" data-courier="'+courier.shippingCourierCode+'" href="#shipping-courier-'+courier.shippingCourierCode+'">',
				arrow = '<i class="icon-chevron-right-red"></i>';

			shipping.couriers[courier.shippingCourierCode] = courier;

			if (!hasRates) {
				anchor = '<a href="javascript:void(0)">';
				arrow = '';
			}

			var $tab = $(
				'<li id="shipping-courier-tab-'+courier.shippingCourierCode+'" class="popover-link">'
					+ anchor
						+ '<span class="name">'+courier.name+'</span>'
						+ arrow
					+ '</a>'
				+ '</li>'
			);

			if (!hasRates) {
				$tab.addClass('hasPopover')
					.popover({
						'html': true,
						'trigger': 'click',//'manual',//'click',
						'placement': 'right',
						'content': function() {
							var msg = courier.name+' carrier has no shipping services available for this order.'
											+ '<br /> <a class="popClose">X</a>';

							if (courier.shippingCourierCode == 'FREIGHT')
								msg += '<br /><br />To receive a freight quote for this order, please contact the sales team'
										  + '<br /> - <span class="pnumber">' + checkout.config.contactInfo.phone + '</span>' + checkout.config.contactInfo.phoneExtra
										  + '<br /> - <a href="mailto:' + checkout.config.contactInfo.email + '" class="mail">' + checkout.config.contactInfo.email + '</a>'
										  + '<br /> - <a href="' + checkout.config.contactInfo.liveChatHref + '" class="lchat">Live Chat</a>'
											+ '<br /> <a class="popClose">X</a>';

							return msg;
						}
					})
					/*  // tip method doesn't work in this environment
						.data(checkout.config.bsPopoverData).tip()
						.find('.popover-title')
						.hide(); */

			}

			courierTabs.push($tab);

		});

		shipping.$couriers.html(courierTabs);

		var $courierTabs = shipping.$couriers.find('a[data-toggle="tab"]');

		$courierTabs.on('show.bs.tab', function(e) {
			var $tab = $(this),
				shippingCourierCode = $(e.target || e.srcElement).data('courier');

			$courierTabs.find('i')
				.removeClass('icon-chevron-right-red')
				.addClass('icon-chevron-right');

			$tab.find('i')
				.removeClass('icon-chevron-right')
				.addClass('icon-chevron-right-red');
		});

		// listen for courier change
		$courierTabs.on('shown.bs.tab', function(e) {
            checkout.session.set({
                'shippingServiceSet': 1
            });
			shipping.changeCourier(
				$(e.target || e.srcElement).data('courier')
			);

			$('.shipping-service input[type="radio"]').each(function(){
				var $this = $(this);
				if ($this.prop('checked') === true) {
					$this.closest('li').css({'background' : '#c8c8c8'}).siblings('li').css({'background' : '#fff'});
				}
			});

			$('.srate .sboxError').html(''); 
			$('.srate .theMessage').html('');
			
			var shippingCourierCode = $(e.target).data('courier');
			var $courierContent = $('#shipping-courier-' + shippingCourierCode);
	
			var invalidRates = [];
			
			for (var shippingServiceCode in invalidCourierRates[shippingCourierCode])
				invalidRates.push(invalidCourierRates[shippingCourierCode][shippingServiceCode]);
			
			if (invalidRates.length > 0) {
				var invalidRatesText = '';
			
				$.each(invalidRates, function(i, invalidRate) {
					
					var service = checkout.shippingServices[invalidRate.shippingServiceCode];
					
					invalidRatesText += '* ' + service.name;
					
					if (invalidRate.cost) {
						invalidRatesText += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;($' + invalidRate.rawCost + ') $' + invalidRate.cost;	
					}

					if (invalidRate.error) {
						invalidRatesText += ': <i>' + invalidRate.error + '</i><br>';
					}

					if(invalidRate.details) {
						if (invalidRate.details.dropship.boxes.length > 0)
							invalidRatesText += '<b>Dropship:</b>';

						$.each(invalidRate.details.dropship.boxes, function(i, dsBox) {
							var products = '';
							$.each(dsBox.products, function(productID, qty) {
								products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
							});
							invalidRatesText +=
								'&nbsp;&nbsp;Box '+ dsBox.length + ' x ' + dsBox.width + ' x ' + dsBox.height + ' (' + dsBox.weight + ' lbs.):<br/>'+ products;
						});
						invalidRatesText += '<br />';

						if (invalidRate.details.warehouse.boxes.length > 0) {
							invalidRatesText += '<b>Warehouse:</b>';
						}

						$.each(invalidRate.details.warehouse.boxes, function(i, wBox) {
							var products = '';
								$.each(wBox.products, function(productID, qty) {
									products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
							});
							invalidRatesText +=
								'&nbsp;&nbsp;Box '+ wBox.length + ' x ' + wBox.width + ' x ' + wBox.height + ' (' + wBox.weight + ' lbs.):<br/>'+ products;
						});
						invalidRatesText += '<br />';
					}
				});

				// show any invalid rates
				$('.srate .sboxError').html('<br /><b>Invalid Rates:</b>' + invalidRatesText + '<br />');
			}

		});

		for (var shippingCourierCode in courierRates) {
			var $courierContent =
					shipping.$courierServicesTpl
						.clone(true)
						.attr('id', 'shipping-courier-'+shippingCourierCode),
				services = [];

			var rates = [];

			for (var shippingServiceCode in courierRates[shippingCourierCode]) {
				rates.push(courierRates[shippingCourierCode][shippingServiceCode]);
			}

			rates.sort(function(a, b) {
				return (a.cost - b.cost);
			});

			$.each(rates, function(i, rate) {
				var service = checkout.shippingServices[rate.shippingServiceCode],
					$service =
						shipping.$serviceTpl
							.clone(true)
							.attr('id', 'shipping-service-'+rate.shippingServiceCode);

				$service.find('.shipping-service-name').html(service.name);

				var rawCostText = '';
				if (rate.rawCost) {
					rawCostText = '($'+rate.rawCost +')';
				}

				var colorAlert = '';

				if (parseInt(rate.rawCost) > parseInt(rate.cost)) {
					colorAlert = 'style="color:red"';
				}

				var serviceCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert +'>' + rawCostText + '</em> ' + '$'+rate.cost;
				if (rate.originalShippingRetail > 0 && rate.originalShippingRetail > rate.cost) {
					serviceCostHTML = '<em class="ecsCost" title="ECS Cost" ' + colorAlert +'>' + rawCostText + '</em> ';
					serviceCostHTML += '<span class="pricecut">$'+rate.originalShippingRetail+'</span>';
					serviceCostHTML += '<span class="discountedCost">$'+rate.cost+'</span>';
				}
				$service.find('.shipping-service-price').html(serviceCostHTML);
				
				if (selectedService.shippingServiceCode == rate.shippingServiceCode)
					$service.find('input[type=radio]').prop('checked', true);

				services.push($service);
			});

			$courierContent.find('ul').html(services);

			if (shippingCourierCode == 'ALT') {
                var notes = checkout.session.get( "alt_ship_notes" );
				var $textArea = $( '<textarea>' ).val( notes );

				$textArea.change(function() {
					checkout.session.set({
						'alt_ship_notes': $textArea.val()
					});
				});

				$courierContent.find('ul').after($textArea);
			}

			couriersContent.push($courierContent);
		}

		shipping.$couriersContent.html(couriersContent);

		// listen for explicit service change
		shipping.$couriersContent
			.find('input[type=radio]')
			.change(function() {
				$(this).closest('li').css({'background' : '#c8c8c8'}).siblings('li').css({'background' : '#fff'});
				var shippingServiceCode =
					$(this)
						.parents('.shipping-service')
						.first()
						.attr('id')
						.replace('shipping-service-', '');

				checkout.session.set({
					'shippingServiceSet': 1
				});

				shipping.changeService(shippingServiceCode);
			});

		$('#shipping-courier-tab-'+selectedService.shippingCourierCode+' a').tab('show');

		shipping.showServiceDesc(selectedService.shippingServiceCode);

		shipping.$serviceServicesWrap.show();
	};

	this.showServiceDesc = function(shippingServiceCode) {
		var service = checkout.shippingServices[shippingServiceCode],
			courier = shipping.couriers[service.shippingCourierCode],
			shippingRatesDetails;

		if (checkout.shippingRatesDetails && checkout.shippingRatesDetails[shippingServiceCode])
			shippingRatesDetails = checkout.shippingRatesDetails[shippingServiceCode];
		
		shipping.$serviceDesc
			.find('.title')
			.html(courier.name + ' - ' + service.name);

		shipping.$serviceDesc
			.find('.body')
			.html(service.description);
		
		var $courierContent = $('#shipping-courier-'+service.shippingCourierCode);
		
		var boxInfoDropShip = '';
		var boxInfoWarehouse = '';
		
		// add drop ship info if available
		if(shippingRatesDetails && shippingRatesDetails.dropship.boxes.length >0) {
			
			boxInfoDropShip = '<b>Direct Ship:</b>' + '<i>(' + shippingRatesDetails.dropship.source  + ')</i><br /><br />';
			
			$.each(shippingRatesDetails.dropship.boxes, function(i, dsBox) {
				var products = '';
				$.each(dsBox.products, function(productID, qty) {
					products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
				});

				boxInfoDropShip +=
					'Box '+ dsBox.length + ' x ' + dsBox.width + ' x ' + dsBox.height + ' (' + dsBox.weight + ' lbs.):<br/>'+ products;

			});
		}
		
		// add warehouse info if available
		if(shippingRatesDetails && shippingRatesDetails.warehouse.boxes.length >0) {
			
			boxInfoWarehouse = '<b>Warehouse:</b>' + '<i>(' + shippingRatesDetails.warehouse.source  + ')</i><br /><br />';
			
			$.each(shippingRatesDetails.warehouse.boxes, function(i, wBox) {
				var products = '';
				$.each(wBox.products, function(productID, qty) {
					products += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +'ES#'+ productID + ' -- ' + qty + 'qty <br />';
				});

				boxInfoWarehouse +=
					'Box '+ wBox.length + ' x ' + wBox.width + ' x ' + wBox.height + ' (' + wBox.weight + ' lbs.):<br/>'+ products;

			});
		}
		
		// show all the details, for debugging purposes only
		//$courierContent.find('.sboxInfo').html( JSON.stringify(shippingRatesDetails, null, 2) );	
		
		$courierContent.find('.sboxInfo').html(boxInfoDropShip + '<br />' + boxInfoWarehouse);

		shipping.$serviceDesc.show();
	};

	this.changeCourier = function(shippingCourierCode) {
		var selectedService = checkout.shippingServices[checkout.shippingServiceCode];

		if (selectedService.shippingCourierCode == shippingCourierCode)
			return;

		shipping.$serviceDesc.hide();

		var $service =
			$('#shipping-courier-'+shippingCourierCode)
				.find('.shipping-service')
				.first();

		$service.find('input[type=radio]').prop('checked', true);

		shipping.changeService(
			$service.attr('id').replace('shipping-service-', '')
		);
	};

	this.changeService = function(shippingServiceCode) {
		var rate = checkout.shippingRates[shippingServiceCode];

		checkout.session.set({
			'shippingServiceCode': shippingServiceCode
		});

		shipping.showServiceDesc(shippingServiceCode);

		if (
			checkout.user
			&& !checkout.session.get('shippingOverride')
		)
			shipping.$overrideAmt.val((parseFloat(rate.cost) || 0).toMoney());

		checkout.shippingServiceCode = shippingServiceCode;

		checkout.cart.shipping.total = (parseFloat(rate.cost) || 0);
		checkout.cart.shipping.originalShippingRetail = (parseFloat(rate.originalShippingRetail) || 0);

		checkout.cart.totals.update('shipping');
	};

	this.showDisclaimers = function() {
		shipping.$disclaimers.html(
            ((checkout.shippingMultiLocations) ?
                '<span class="multi-loc">Your order will ship from multiple locations.</span>'
                : ''
            )
            + ((checkout.config.siteAbbr != 'ECS') ? '<span class="nopickup">' + checkout.config.siteName + ' does not offer in-store pickup</span>' : '')
        );
	};

	this.buildOverride = function() {
		if (checkout.user) {
			var overrideAmt = checkout.session.get('shippingOverrideAmt');

			if (checkout.session.get('shippingOverride')) {
				shipping.$override.prop('checked', true);
				shipping.$overrideAmt.val((parseFloat(overrideAmt) || 0).toMoney());
			} else
				shipping.$overrideAmt.val(checkout.cart.totals.values.shipping);

			shipping.$overrideWrap.show();
		}
	};

	this.changeDisplayType = function() {
		var selectedDisplayType = $(this).val();

		checkout.session.set({
			'shippingDisplayType': selectedDisplayType,
		});

		checkout.cart.totals.calc(true);
	}

	this.changeOverride = function() {
		var override = (shipping.$override.prop('checked') ? 1 : 0),
			overrideAmt = (parseFloat(shipping.$overrideAmt.val()) || 0);

		checkout.session.set({
			'shippingOverride': override,
			'shippingOverrideAmt': overrideAmt
		});

		checkout.cart.totals.update('shipping');
	};

    this.showRatesDetails = function( groupRate ) {
        var details = groupRate.details;
        if(! details) {
            shipping.$groupDetailsContainer.hide();
            return;
        }

        var descriptions = [];

        var dropship = details.dropship;
        if(dropship
            && dropship.boxes
            && dropship.boxes.length > 0
            ) {
            descriptions.push(
                getShipmentDescription( dropship, 'Direct Ship' )
            );
        }

        var warehouse = details.warehouse;
        if(warehouse
            && warehouse.boxes
            && warehouse.boxes.length > 0
            ) {
            descriptions.push(
                getShipmentDescription( warehouse, 'Warehouse' )
            );
        }

        var descriptionHTML = descriptions.join("<br /><br />");
        shipping.$groupDetailsContainer.html( descriptionHTML ).show();
    };

    var getShipmentDescription = function(shipment, name) {
        var description = [];

        description.push(
            '<b>' + name + ':</b>' +
            '<i>(' + shipment.source + ')</i>'
        );
        $.each(shipment.boxes, function(i, box) {
            description.push(
                'Box ' + box.length +
                ' x ' + box.width +
                ' x ' + box.height +
                ' (' + box.weight + ' lbs.):'
            );
            $.each(box.products, function(productID, qty) {
                description.push(
                    '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                    'ES#' + productID +
                    ' -- ' +
                    qty + ' qty'
                );
            });
        });

        return description.join("<br />");
    };

	this.init();
};

